var render = function render(_c,_vm){return _c('b-col',{staticClass:"one-product-description"},[_c('div',{staticClass:"one-product-description__text py-1",domProps:{"innerHTML":_vm._s(_vm.props.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }